// extracted by mini-css-extract-plugin
export default {"iframe":"survey-module--iframe--22b7c"};